module.exports = __webpack_public_path__ + "media/assets/images/blog/no_managers-small-a21d6fd43dc55c98166e1f1da3fdbd45.png";